export default "__VITE_ASSET__DDt8Ln_g__"